<div class="report-container warehouse-inventory">


    <app-report-sub-menu [menuList]="overViewMenu" (menuChangeValue)="menuChangeValue($event)"></app-report-sub-menu>
    <ng-container *ngIf="overViewLoading">
        <app-skeleton-loader [reportType]="chartView.overView" [height]="'150px'"></app-skeleton-loader>
    </ng-container>
    <div class="report-tabsection" id="{{ WarehouseInventoryv2MenuEnum.overview}}"
        [ngClass]="{ 'scroll': currentScroll === WarehouseInventoryv2MenuEnum.overview}">

        <div class="report-overview report-overview-3col" *ngIf="!overViewLoading">
            <app-warehouse-overview-card 
                [card_title]="'reports.totalProperties'"
                [overviewData]="overViewSummary?.total_properties"
                [box]="'1'"></app-warehouse-overview-card>
            <app-warehouse-overview-card 
                [card_title]="'reports.total_area'"
                [overviewData]="overViewSummary?.total_area"           
                [uniType]="UnitTypeEnum.sqm"
                [box]="'2'"></app-warehouse-overview-card>
            <app-warehouse-overview-card 
                [card_title]="'reports.transaction_rate'"
                [overviewData]="overViewSummary?.transaction_rate"
                [uniType]="UnitTypeEnum.currencywithsqm"
                [box]="'3'"></app-warehouse-overview-card>
        </div>

        <div class="report-overview report-overview-2col">
            <app-overview-card *ngIf="!overViewLoading"
                [card_title]="sharedService.priceCalculation$() === sharedService.priceYearly ? 'reports.annualAverageRentRateGradeWise':'reports.averageRentRateGradeWise'"
                [uniType]="UnitTypeEnum.currencywithsqm"
                [graphData]="{data: overviewAverageRate, type: 'averageRentRate'}" 
                [untillDate]="overViewAverageSummary?.untillDate"
                [propertiesCount]="gradeProperties"
                [gradeWise]="true"></app-overview-card>

            <app-warehouse-overview-rental-yield *ngIf="!overViewRentalYieldLoading"
                [card_title]="'reports.rentalYield'"
                [uniType]="UnitTypeEnum.percentage"
                [graphData]="{data: overViewRentalYieldSummary?.data, type: 'averageRentRate'}"
                [untillDate]="overViewRentalYieldSummary?.untillDate"
                [gradeWise]="true"
                [propertiesCount]="rentalYieldProperties"
            ></app-warehouse-overview-rental-yield>
                
        </div>
        <div class="property-infod">
            <div class="property-information">
                <div class="retail-heading">
                    <h2 class="detail-heading">{{sharedService.priceCalculation$() === sharedService.priceYearly ? ('reports.Annual_Built_Up_Inventory' | translate) :('reports.Built_Up_Inventory' | translate) }} {{'sqm' | translate}}</h2>
                    <app-dropdown-radio-selection *ngIf="allTypeChart.length" [dropDownOption]="developerDropdown"
                        (dropDownValue)="dropDownChange($event, 'all_type')"
                        [showInvalueText]="false"></app-dropdown-radio-selection>
                </div>
                <div class="chart-div">
                    <ng-container *ngIf="alltypeLoading">
                        <app-skeleton-loader [reportType]="chartView.barChart"
                        ></app-skeleton-loader>
                    </ng-container>
                    <ng-container *ngIf="!alltypeLoading">
                        <ng-container *ngIf="allTypeChart.length; else noDataMessage2">
                            <ng-container *ngIf="selected_chart_alltype == 'Cumulative'">
                                <app-report-charts [data]="allTypeChart" [chartType]="chartView.barChart"
                                    [isBorder]="false"></app-report-charts>
                            </ng-container>
                            <ng-container *ngIf="selected_chart_alltype == 'Incremental'">
                                <app-waterfall-chart class="directionLtr" [chartId]="'alltype'" [showSideValue]="false"
                                 [data]="allTypeWaterfallChart"></app-waterfall-chart>
                            </ng-container> 
                            <div class="chart-label">
                                <p>{{'reports.All_Types' | translate }}</p>
                            </div>
                        </ng-container> 
                        <ng-template #noDataMessage2>
                            <div class="data_unavail">
                                <span>
                                    {{"reports.data_not_available" | translate}} <mat-icon role="img"
                                        class="mat-icon notranslate material-icons mat-ligature-font mat-icon-no-color"
                                        aria-hidden="true" data-mat-icon-type="font">equalizer</mat-icon>
                                </span>
                            </div>
                        </ng-template>                  
                    </ng-container>
                </div>
               
            </div>
            <div class="property-information">
                <div class="retail-heading">
                    <h2 class="detail-heading">{{sharedService.priceCalculation$() === sharedService.priceYearly ? ('reports.Annual_Vacant_Land_Area' | translate) : ('reports.Vacant_Land_Area' | translate) }} {{'sqm' | translate}}</h2>
                    <app-dropdown-radio-selection *ngIf="categoryChart.length" [dropDownOption]="developerDropdown"
                        (dropDownValue)="dropDownChange($event, 'category')"
                        [showInvalueText]="false"></app-dropdown-radio-selection>
               </div>
                 <div class="chart-div">
                     <ng-container *ngIf="categoryChartLoading">
                        <app-skeleton-loader [reportType]="chartView.barChart"
                        ></app-skeleton-loader>
                    </ng-container>
                    <ng-container *ngIf="!categoryChartLoading">
                        <ng-container *ngIf="categoryChart.length; else noDataMessage1">
                            <ng-container *ngIf="selected_chart_category == 'Cumulative'">
                                <app-report-charts [data]="categoryChart" [chartType]="chartView.barChart"
                                     [isBorder]="false" [name]="'category'"></app-report-charts>
                            </ng-container>
                            <ng-container *ngIf="selected_chart_category == 'Incremental'">
                                <app-waterfall-chart class="directionLtr" [chartId]="zoningList" [showSideValue]="false" 
                                [data]="categoryWaterfallChart"></app-waterfall-chart>
                            </ng-container>
                            <div class="chart-label">
                                <p matTooltip="{{zoningList}}">{{ zoningList }}</p>
                            </div>
                        </ng-container>
                        <ng-template #noDataMessage1>
                            <div class="data_unavail">
                                <span>
                                    {{"reports.data_not_available" | translate}} <mat-icon role="img"
                                        class="mat-icon notranslate material-icons mat-ligature-font mat-icon-no-color"
                                        aria-hidden="true" data-mat-icon-type="font">equalizer</mat-icon>
                                </span>
                            </div>
                        </ng-template>
                    </ng-container>
                </div>
            </div>

            
        </div>

        <div class="report-model report-rentrate">
                <div class="report-model-header">
                    <div class="info">
                        <h3>{{sharedService.priceCalculation$() === sharedService.priceYearly ?
                            ('reports.Annual_Rent_Rate_By_Category' | translate) : ('reports.Rent_Rate_By_Category' | translate)}}
                        </h3>
                    </div>
                    <button class="btn-select-grade" [matMenuTriggerFor]="menu"
                        *ngIf="!warehouserentChartLoading && (wharehouserentChartReport | json) != '{}' && (wharehouserentChartReport | json) != '[]'">
                        <div class="setext">
                            <ng-container *ngFor="let name of selectedChartValue; let l = last">{{name}}<span *ngIf="!l"
                                    style="padding-right: 2px;">,</span></ng-container>
                        </div>
                        <span class="morecount" *ngIf="selectedChartValue.length > 1">{{moreText}}</span>
                        <mat-icon>keyboard_arrow_down</mat-icon>
                    </button>

                    <mat-menu #menu="matMenu" [xPosition]="langName === 'ar' ? 'after' : 'before'"
                        class="grades-menu directionLtr">
                        <div (click)="$event.stopPropagation()">
                            <h5>{{'reports.choose_maximum_options' | translate}}</h5>
                            <ng-container *ngFor="let category of getReportKeys()">
                                <mat-checkbox (change)="selectChart($event, category)"
                                    [checked]="selectedChartValue.includes(category)">{{category}}</mat-checkbox>
                            </ng-container>
                        </div>
                    </mat-menu>

                </div>
                <ng-container *ngIf="warehouserentChartLoading">
                    <app-skeleton-loader [reportType]="chartView.barChart"></app-skeleton-loader>
                </ng-container>
                <ng-container *ngIf="!warehouserentChartLoading">
                    <div class="multiBarChart d-flex"
                    *ngIf="(wharehouserentChartReport | json) != '{}' && (wharehouserentChartReport | json) != '[]'; else noDataMessage">
                        <ng-container *ngFor="let chart of wharehouserentChartReport | keyvalue: keyOrder; let i = index">
                            <app-report-charts class="grchart" [data]="chart.value"
                                [chartType]="chartView.smallBarChart" [isBorder]="false" [name]="chart.key" [index]="i"
                                [ngStyle]="{'min-width': (wharehouserentChartReport | keyvalue).length == 1 ? '100%' : '300px'}">
                            </app-report-charts>
                        </ng-container>


                    </div>
                    <ng-template #noDataMessage>
                        <div class="data_unavail">
                            <span>
                                {{"reports.data_not_available" | translate}} <mat-icon role="img"
                                    class="mat-icon notranslate material-icons mat-ligature-font mat-icon-no-color"
                                    aria-hidden="true" data-mat-icon-type="font">equalizer</mat-icon>
                            </span>
                        </div>
                    </ng-template>
                </ng-container>
            </div>

        
    </div>

    <!-- unitSizeWise -->
    <div class="report-tabsection" [ngClass]="{ 'scroll': currentScroll === WarehouseInventoryv2MenuEnum.unitSizeWise}"
        id="{{ WarehouseInventoryv2MenuEnum.unitSizeWise }}">

       
        <div class="report-model">
            <app-datatable-title [title]="sharedService.priceCalculation$() === sharedService.priceYearly ? 'reports.annualRentUnitSizeWise' : 'reports.rentUnitSizeWise'" [isShowCount]="false"></app-datatable-title>
            <app-warehouse-rental-unit-size
                    [showLoader]="!warehouseUnitsizeLoading"
                    [tableColumns]="warehouseUnitsizeColumns"
                    [tableData]="warehouseUnitsizedata"
                    [allowExcelDownload]="true"
                    (excelDownload)="downloadExcel($event, 'warehouse_rental_unitsize_v2', 'a','warehouse_rental')"
                    [downloadLoading]="downloadLoading['a']" [showEstaterText]="true" 
                    [dropDownOption]="unitSizeDropdown"
                    [table_Title]="(sharedService.priceCalculation$() === sharedService.priceYearly ? ('reports.annualRentUnitSizeWise' | translate) : ('reports.rentUnitSizeWise' | translate))"
                    ></app-warehouse-rental-unit-size>

        </div>
    </div>

    <!-- project -->
    <div class="report-tabsection" [ngClass]="{ 'scroll': currentScroll === WarehouseInventoryv2MenuEnum.project}"
        id="{{ WarehouseInventoryv2MenuEnum.project }}">

    
        <div class="report-model">

            <app-datatable-title [title]="'reports.project'" [count]="projectCount" [countTitle]="'reports.totalProjects'"></app-datatable-title>

            <app-warehouse-inventory-project
                [showLoader]="!projectLoading" 
                [ngClass]="{'activeTable': tableName == WarehouseInventoryv2MenuEnum.project}"
                (lastClickedTable)="lastClickedTable($event, WarehouseInventoryv2MenuEnum.project)"
                [tableColumns]="inventoryProjectColumns" 
                [dataLength]="projectCount"
                [tableData]="warehouseProjectdata" 
                (pageEvent)="onPageEvent($event, WarehouseInventoryv2MenuEnum.project)"
                (excelDownload)="downloadExcel($event, 'warehouse_rental_projects_v2', 'b', 'warehouse_rental')"
                [downloadLoading]="downloadLoading['b']" [showEstaterText]="true"
                [dropDownOption]="unitSizeDropdown"
                >                
            </app-warehouse-inventory-project>
        </div>
    </div>

  <!-- Land price -->
    <div class="report-tabsection" [ngClass]="{ 'scroll': currentScroll === WarehouseInventoryv2MenuEnum.landprices}"
        id="{{ WarehouseInventoryv2MenuEnum.landprices }}">

      
        <div class="report-model">

            <div class="report-model-header">
                <div class="info w-72">
                    <h3>{{"reports.landprices" | translate}}</h3>
                    <span class="totalTransaction">({{ landpriceActualCount | number:'1.0-1' }} {{"reports.actual_transactions_with" | translate}} 
                        {{ landpriceAuctionCount | number:'1.0-1' }} {{"reports.auctions" | translate}} 
                        {{"reports.andSymbol" | translate}} 
                        {{ landpriceEstimatedCount | number:'1.0-1' }} {{"reports.quotes" | translate}})</span>
                </div>
            </div>

            <app-warehouse-inventory-landprice 
                [dataLength]="landpriceCount"
                [showLoader]="!landpricedataLoading" 
                [ngClass]="{'activeTable': tableName == WarehouseInventoryv2MenuEnum.landprices}"
                (lastClickedTable)="lastClickedTable($event, WarehouseInventoryv2MenuEnum.landprices)"
                [tableColumns]="inventoryLandPriceColumns" 
                [tableData]="landpricedata" 
                (pageEvent)="onPageEvent($event, WarehouseInventoryv2MenuEnum.landprices)"
                (excelDownload)="downloadExcel($event, 'warehouse_details_land_price_transaction', 'c')"
                [downloadLoading]="downloadLoading['c']"
                [dropDownOption] = "transactionType"
                (dropDownValue)="selectionChange($event, WarehouseInventoryv2MenuEnum.landprices)" 
                [resetPaginator]="resetPaginator"
            >
            </app-warehouse-inventory-landprice>
        </div>
    </div>

      <!-- property Transactions -->
    <div class="report-tabsection" [ngClass]="{ 'scroll': currentScroll === WarehouseInventoryv2MenuEnum.propertyTransaction}"
        id="{{ WarehouseInventoryv2MenuEnum.propertyTransaction }}">

        <div class="report-model">
            <div class="report-model-header">
                <div class="info w-72">
                    <h3>{{"reports.property_prices" | translate}}</h3>
                    <span class="totalTransaction">({{ propertyTransactionActualCount | number:'1.0-1' }} {{"reports.actual_transactions_with" | translate}} 
                        {{ propertyTransactionAuctionCount | number:'1.0-1' }} {{"reports.auctions" | translate}} 
                        {{"reports.andSymbol" | translate}} 
                        {{ propertyTransactionEstimatedCount | number:'1.0-1' }} {{"reports.quotes" | translate}})</span>
                </div>
            </div>

            <app-warehouse-inventory-property-transaction 
                [showLoader]="!propertyTransactiondataLoading" 
                [ngClass]="{'activeTable': tableName == WarehouseInventoryv2MenuEnum.propertyTransaction}"
                (lastClickedTable)="lastClickedTable($event, WarehouseInventoryv2MenuEnum.propertyTransaction)"
                [tableColumns]="inventorypropertyTransaColumns" 
                [dataLength]="propertyTransactionCount"
                [tableData]="propertyTransactiondata" 
                (pageEvent)="onPageEvent($event, WarehouseInventoryv2MenuEnum.propertyTransaction)"
                (excelDownload)="downloadExcel($event, 'warehouse_details_building_price_transaction', 'd')"
                [dropDownOption] = "transactionType"
                (dropDownValue)="selectionChange($event, WarehouseInventoryv2MenuEnum.propertyTransaction)" 
                [resetPaginator]="resetPaginator1"
                [downloadLoading]="downloadLoading['d']"
            >
            </app-warehouse-inventory-property-transaction>
        </div>
    </div>


</div>